import { AuctionStatus } from '../../../api-client/enums'
import RemainingTime from '../../../components/remaining-time'
import useVehiclePageData from '../use-vehicle-page-data'
import { useCallback } from 'react'
import Loader from '../../../components/loader'
import { parseISO } from '../../../utils/date-service'

export default function AuctionInfo() {
  const { auctionInfo, startAuctionInfoPolling, auctionInfoPollingEnabled } = useVehiclePageData()

  const handleAuctionTimerExpired = useCallback(() => {
    startAuctionInfoPolling()
  }, [startAuctionInfoPolling])

  if (!auctionInfo) return null

  return (
    <div className='auctionInfo flex alignCenter justifyBetween'>
      {auctionInfo.auctionStatus === AuctionStatus.Live ? (
        <>
          <div className='remainingTime'>
            <div className='value'>
              {auctionInfo.endDate && (
                <RemainingTime
                  endDate={parseISO(auctionInfo.endDate, { withTime: true })}
                  timeZone={auctionInfo.timeZone}
                  onExpire={handleAuctionTimerExpired}
                />
              )}
              {auctionInfoPollingEnabled && (
                <Loader width='16' height='16' style={{ marginLeft: 6 }} />
              )}
            </div>
            <div className='label'>Remaining Time</div>
          </div>
          <div className='myBid'>
            <div className='value'>
              {auctionInfo.currentUserBidAmount?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }) ?? 0}
            </div>
            <div className='label'>My Bid</div>
          </div>
        </>
      ) : auctionInfo.auctionStatus === AuctionStatus.Scheduled ? (
        <div className='fluid'>
          <div className='value'>
            {auctionInfo.startDate ? (
              <>
                <RemainingTime
                  endDate={parseISO(auctionInfo.startDate, { withTime: true })}
                  timeZone={auctionInfo.timeZone}
                  onExpire={handleAuctionTimerExpired}
                />
                {auctionInfoPollingEnabled && (
                  <Loader width='16' height='16' style={{ marginLeft: 6 }} />
                )}
              </>
            ) : null}
          </div>
          <div className='label'>Auction starts in</div>
        </div>
      ) : auctionInfo.auctionStatus === AuctionStatus.Ended ? (
        <div className='myBid fluid'>
          <div className='value'>
            {auctionInfo.currentUserBidAmount?.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }) ?? 0}
          </div>
          <div className='label'>My Bid</div>
        </div>
      ) : null}

      <style jsx>{`
        .auctionInfo {
          margin: 1rem 0;
          padding: 0.6rem 0;
          border-radius: 1rem;
          background: #1a1e21;
        }

        .remainingTime,
        .myBid {
          width: 47%;
          text-align: center;
        }

        .fluid {
          width: 100%;
          text-align: center;
        }

        .value {
          color: var(--primary-color);
          font-size: 1.8rem;
          font-weight: 700;
        }

        .label {
          color: var(--secondary-text-color);
          font-size: 1.2rem;
        }

        @media (max-width: 1024px) {
          .auctionInfo {
            width: 100%;
            margin: 0 1.2rem 0 0;

            .value {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
